<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner color="primary" mode="indeterminate"></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'memberships_title' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'memberships_subTitle' | translate }}</div>
  <br />
  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <mat-sidenav-container [hasBackdrop]="false">
      <mat-sidenav class="sidenav-panel" #sidenav mode="over" position="end" [fixedInViewport]="true"
        [fixedTopGap]="isMobile() ? 120 : 64" [disableClose]="true">
        <app-membership-add *ngIf="accountSelectedId !== 0" 
          [account_id]="accountSelectedId"
          (saved)="sidenav.close(); membershipAdded($event)"
          (cancelled)="sidenav.close(); membershipCancelled($event)" 
          (loadingSpinner)="loadingSpinner($event)">
        </app-membership-add>
      </mat-sidenav>
    </mat-sidenav-container>

    <div fxLayout="row wrap" fxLayoutAlign="space-between">
        <div fxLayout="row" fxLayoutAlign="start center">
            <!-- <p>{{ 'select_account' | translate }}: </p> -->
            <app-account-selector-input-async 
            [isAccountsAll]="true"
            (loadingSpinner)="loadingSpinner($event)"
            (selected)="accountChanged($event)" 
            (cleared)="accountCleared()">
            </app-account-selector-input-async>
        </div>
        <div *ngIf="accountSelectedId !== 0">
          <br/>
          <a mat-raised-button color="primary" (click)="sidenav.open()">
            <mat-icon>add</mat-icon>{{ 'add_membership' | translate }}
          </a>
        </div>
    </div>

    <div  *ngIf="(media.isActive('lg') || media.isActive('xl') || media.isActive('md')) && accountSelectedId !== 0" class="matTable-container">
      <mat-table matSort #table [dataSource]="dataSource"
        class="mat-elevation-z8">

        <!-- Members Column -->
        <ng-container cdkColumnDef="members">
          <mat-header-cell fxFlex="80%" *cdkHeaderCellDef mat-sort-header>{{ 'members' | translate }}</mat-header-cell>
          <mat-cell fxFlex="80%" *cdkCellDef="let membership"> {{membership.name}} </mat-cell>
        </ng-container>

        <ng-container cdkColumnDef="menu">
          <mat-header-cell fxFlex="20%" *cdkHeaderCellDef></mat-header-cell>
          <mat-cell fxFlex="20%" *cdkCellDef="let membership">

            <button mat-icon-button [matMenuTriggerData]="{ row: membership }" [matMenuTriggerFor]="menu" *ngIf="isAdministrator">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="deleteMembership(membership)" matTooltip="Delete Membership"
                matTooltipPosition="left">
                {{ 'delete' | translate }}
              </button>
            </mat-menu>

          </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
      </mat-table>
    </div>
    
    <br />

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))">
      <ng-template ngFor let-membership [ngForOf]="dataSource.data">
        <mat-list-item>
          <div class="mobile-item">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
              <div fxFlex="30%"><b>{{ 'Member' | translate }}:</b></div>
              <div class="breakword" fxFlex>{{membership.name}}</div>
            </div>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px" *ngIf="isAdministrator">
              <a mat-raised-button color="warn" (click)="deleteMembership(membership)">
                {{ 'delete' | translate }}
              </a>
            </div>
          </div>
        </mat-list-item>
        <mat-divider></mat-divider>
      </ng-template>
    </mat-list>

  </con-page-layout-content>
</con-page-layout>
